import React, {CSSProperties, memo, ReactNode} from 'react';
import './index.scss';

type Props = {
    children?: ReactNode;
    style?: CSSProperties;
};

export const Widget = memo(function Widget({children, style}: Props) {
    return (
        <div className="widget-wrapper" style={style}>
            <div className="widget-content">
                {children}
            </div>
        </div>
    );
});
